// extracted by mini-css-extract-plugin
module.exports = {"container":"ButtonC_container__22GBt","title":"ButtonC_title__1S0NP","rightIcon":"ButtonC_rightIcon__J1us1","leftIcon":"ButtonC_leftIcon__1mxDw"};